import { createSelector } from 'reselect'

export const getFavouritePublishedAdsLoading = createSelector(
  state => state && state.user && state.user.profile
    && state.user.profile.favouriteAds
  ? state.user.profile.favouriteAds.Published.isLoading : false,
 	isLoading => isLoading
)
